// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dogley-language-picker {\r\n  list-style-type: none;\r\n}\r\n\r\n.dogley-language-picker li {\r\n  display: block;\r\n}\r\n\r\n.dogley-language-picker li a {\r\n  display: block;\r\n  padding: .5rem;\r\n}\r\n", ""]);
// Exports
module.exports = exports;
